import { MDCTextField } from '@material/textfield'

export default {
  setup() {
    this.textField = new MDCTextField(this.el)
    // disabled "NativeValidation" so that we can control the valid state from ecto changesets
    // if not disabled MD will assume HTML5 validation only and will override our inclusion of the invalid class on divs
    this.textField.foundation.setUseNativeValidation(false)
    // through playing with this it still seems that we have to tell it the valid state even though we're controlling the classes
    this.textField.foundation.setValid(this.el.dataset.invalid !== 'true')
  },
  destroy() {
    this.textField?.destroy()
    this.textField = null
  },
  mounted() {
    this.setup()
  },
  beforeUpdate() {
    this.destroy()
  },
  updated() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
